module.exports = __webpack_public_path__ + "img/download_logo.e3262b59.png";